<template>

  <section class="relative pt-24 pb-6 text-white bg-lifeboost-blue-dark lg:pt-8 lg:pb-14">
    <div
      class="relative flex flex-wrap items-center justify-between px-5 pt-3 mx-auto max-w-screen-2xl md:px-7 lg:px-14 xl:px-20 2xl:px-12 lg:pt-4">
      <div
        class="flex flex-wrap items-center justify-center w-full mb-6 text-xs lg:w-auto lg:justify-start lg:text-sm lg:mb-0 md:space-x-12">
        <p class="block w-full mb-3 text-center md:w-auto md:mb-0" v-html="text"></p>

        <a :href="link1Href" class="block w-1/2 text-center text-white md:w-auto hover:text-lifeboost-red"
          v-html="link1"></a>

        <a :href="link2Href" class="block w-1/2 text-center text-white md:w-auto hover:text-lifeboost-red"
          v-html="link2"></a>

        <a :href="link3Href" class="block w-1/2 text-center text-white md:w-auto hover:text-lifeboost-red"
          v-html="link3"></a>

      </div>
      <div class="flex flex-wrap items-center justify-center w-full text-sm lg:w-auto lg:justify-end">
        Contact: &nbsp;<a class="underline" :href="link4Href" v-html="link4"></a>&nbsp;|&nbsp;<a class="underline"
          :href="`tel:` + phone" v-html="phone"></a>
      </div>
    </div>
  </section>



</template>

<style>
.zls-1 {
  color: #fff;
  fill: #fff;
}
</style>

<script setup>
defineProps({

  text: {
    type: String,
    default: '2025 © Lifeboost Group Inc.',
  },
  link1: {
    type: String,
    default: 'Privacy Policy'
  },
  link1Href: {
    type: String,
    default: '/pages/privacy'
  },
  link2: {
    type: String,
    default: 'Terms &amp; Conditions'
  },
  link2Href: {
    type: String,
    default: '/pages/terms'
  },
  link3: {
    type: String,
    default: 'Web Accessibility Policy'
  },
  link3Href: {
    type: String,
    default: 'https://lifeboostcoffee.com/pages/web-accessibility-policy'
  },
  link4: {
    type: String,
    default: 'support@lifeboostcoffee.com'
  },
  link4Href: {
    type: String,
    default: 'mailto:support@lifeboostcoffee.com'
  },
  phone: {
    type: String,
    default: '1-800-479-1596'
  },

})

defineBuilderComponent({
  friendlyName: "Footer1",
  canHaveChildren: true,
  inputs: [
    {
      name: "text",
      type: "richText",
      defaultValue: "2025 © Lifeboost Group Inc."
    },
    {
      name: "link1",
      type: "richText",
      defaultValue: "Privacy Policy"
    },
    {
      name: "link1Href",
      type: "text",
      defaultValue: "/pages/privacy"
    },
    {
      name: "link2",
      type: "richText",
      defaultValue: "Terms & Conditions"
    },
    {
      name: "link2Href",
      type: "text",
      defaultValue: "/pages/terms"
    },
    {
      name: "link3",
      type: "richText",
      defaultValue: "Web Accessibility Policy"
    },
    {
      name: "link3Href",
      type: "text",
      defaultValue: "https://lifeboostcoffee.com/pages/web-accessibility-policy"
    },
    {
      name: "link4",
      type: "richText",
      defaultValue: "support@lifeboostcoffee.com"
    },
    {
      name: "link4Href",
      type: "text",
      defaultValue: "mailto:support@lifeboostcoffee.com"
    },
    {
      name: "phone",
      type: "richText",
      defaultValue: "1-800-479-1596"
    }
  ]
});
</script>